import { v4 as uuidv4 } from "uuid";

/**
 * Generate a random UUID v4 that works in every context.
 *
 * `crypto.randomUUID` is only defined in **secure contexts** (HTTPS / localhost) and not in older
 * browsers, so calling it directly crashed flows like opening a knowby with
 * "crypto.randomUUID is not a function". Prefer the native API when available, otherwise fall back
 * to the `uuid` package, which uses `crypto.getRandomValues` (available in non-secure contexts too).
 */
export function newUuid(): string {
	return typeof crypto !== "undefined" && typeof crypto.randomUUID === "function" ? crypto.randomUUID() : uuidv4();
}
